module.exports = __webpack_public_path__ + "static/media/yellow-cab.de1809bf.png";